<template>
  <div v-if="partner" class="coop-entry">
    <img class="coop-entry-bg" :src="partner.entryBg" alt="BMW 车主专属福利">

    <div class="coop-entry-bar">
      <img class="coop-entry-btn" :src="partner.entryBtn" alt="">
      <button class="coop-entry-hotspot" type="button" aria-label="点击领取" @click="goLogin"></button>
    </div>
  </div>
</template>

<script>
import { getPartner } from './partners'

export default {
  name: 'CoopEntry',
  data() {
    return {
      partnerCode: '',
      partner: null
    }
  },
  created() {
    this.partnerCode = this.$route.params.partner
    this.partner = getPartner(this.partnerCode)
    if (!this.partner) {
      this.$router.replace('/')
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/coop/' + this.partnerCode + '/login')
    }
  }
}
</script>

<style scoped>
.coop-entry {
  min-height: 100vh;
  /* 取长图顶部的蓝, 图未加载完时不闪白; 图加载后整页被图撑满, 这个色看不到 */
  background-color: #1B5A96;
}

/* 长图按宽度等比缩放, 高度自然撑开, 页面正常滚动 */
.coop-entry-bg {
  display: block;
  width: 100%;
}

/*
 * 按钮图四周是透明留白, 直接浮在海报上, 不加底色。
 * 整条 bar 关掉指针事件, 只有热区可点 —— 否则底部 40vw 的透明区域
 * 会把海报上的点击全吃掉, 用户点正文也会跳转。
 */
.coop-entry-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.coop-entry-btn {
  display: block;
  width: 100%;
}

/* 热区对齐按钮图里的可见区域: 画布 750x300, 可见 x123~620 / y98~189 */
.coop-entry-hotspot {
  position: absolute;
  left: 16.4%;
  right: 17.2%;
  top: 32.67%;
  height: 30.67%;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background-color: transparent;
  pointer-events: auto;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.coop-entry-hotspot:active {
  background-color: rgba(0, 0, 0, 0.12);
}
</style>
